// import moment from "moment";
import dayjs from "dayjs";

function setTokenExpire() {
  const expire = dayjs().add(30, "d");
  window.sessionStorage.setItem("tokenExpire", expire);
}

export function getToken() {
  return window.sessionStorage.getItem("token") || null;
}

export function setToken(token) {
  window.sessionStorage.setItem("token", token);
  setTokenExpire();
}

export function isExpire() {
  const tokenExpireDate = window.sessionStorage.getItem("tokenExpire");
  const expireMoment = dayjs(tokenExpireDate);

  if (expireMoment.isBefore(dayjs())) return true;
  else return false;
}
